import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/routeHead";
import GuidesIndex from "@/pages/GuidesIndex";
import { guidesIndexQueryOptions } from '@/lib/guideQueries';

export const Route = createFileRoute("/guide/")({
  loader: ({ context }) => context.queryClient.ensureQueryData(guidesIndexQueryOptions()),
  errorComponent: () => <div role="alert">The guides could not be loaded. Please try again.</div>,
  notFoundComponent: () => <div>No guides found.</div>,
  head: () => pageHead({
    title: "RV Buyer's Guides",
    description: 'Expert RV buying guides from Rex & Sons RVs — compare travel trailers, fifth wheels and motorhomes to find your perfect fit.',
    path: '/guide',
  }),
  component: GuidesIndex,
});